import script from "./SectionCampaigns.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionCampaigns.vue?vue&type=script&setup=true&lang=js"

import "./SectionCampaigns.vue?vue&type=style&index=0&id=7b1783d6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b1783d6"]])

export default __exports__